/**
 * Raw hex values for design tokens. Used by `theme/tokens.ts` and helpers.
 * @see https://chakra-ui.com/docs/theming/customization/colors
 */

export const brandScaleHex = {
  50: '#edfaf4',
  100: '#d1f5e6',
  200: '#a8ebd0',
  300: '#7adfb8',
  400: '#56d69f',
  500: '#3ECF8E',
  600: '#34b87c',
  700: '#299D69',
  800: '#1e754f',
  900: '#134d34',
  950: '#0a261a',
} as const;

/**
 * App surfaces (dark theme):
 * - sidebarbg: sidebar column
 * - secondary: main canvas (auth + dashboard)
 * - dark: elevated panels (cards, inputs)
 * Text: body (primary on dark), body2 (muted), secondary2 (light grey on dark UI)
 */
export const appColorsHex = {
  lightPrimary: '#1D2E36',
  secondary: '#17181d',
  secondary2: '#E5E5EB',
  sidebarbg: '#121318',
  body: '#FCFCFC',
  body2: '#757575',
  warning: '#FF964D',
  success: '#2BAC47',
  error: '#FF3E3A',
  lightError: '#ff9999',
  dark: '#22242c',
  lightBg: '#FBEFEF',
  invisibleLabel: '#10002E',
  info: '#17a2b8',
  sumsub: '#20252C',
} as const;

/** Flat map for JS utilities outside Chakra props. */
export const colors = {
  primary: brandScaleHex[500],
  darkPrimary: brandScaleHex[700],
  ...appColorsHex,
} as const;

export type AppColorName = keyof typeof colors;
